
export const formatDate = (dateString:Date) =>{
     var date = new Date(dateString);
    return new Intl.DateTimeFormat('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }).format(date);
}

export const stringToDate = (dateString:string) =>{
     var date = new Date(dateString);
    return new Intl.DateTimeFormat('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }).format(date);
}

export const formatDateForInput = (value: string): string => {
  if (!value) return '';
  const [year, month, day] = value.split('T')[0].split("-");
  return `${year}-${month}-${day}`;
}; 

export const toDateOnly = (date: Date): string => {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0'); 
  const day = date.getDate().toString().padStart(2, '0');
  return `${year}-${month}-${day}`;
}
export const formatDateForOutput = (value: string): string => {
  if (!value) return '';
  const [year, month, day] = value.split('-');
  return `${day}-${month}-${year}`;
};

export const explicitConvertToDateOnly=(stringDate:string)=>{
  if(!stringDate.includes("/")) return stringDate;
  return stringDate.replace("/", "-");
}

export const formatTime = (time: string): string => {
  const timeParts = time.split(':');
  if (timeParts.length > 3) {
    return `${timeParts[0]}:${timeParts[1]}:${timeParts[2]}`;
  }
  if (timeParts.length === 2) {
    return `${timeParts[0]}:${timeParts[1]}:00`;
  }
  return time;
};


export const addDays = (date: Date, days: number): Date =>{
  date.setDate(date.getDate() + days);
  return date;
}


export const  addDaysToDate = (date: Date, days: number): Date=> {
  const result = new Date(date); 
  result.setDate(result.getDate() + days); 
  return result;
}